import React from 'react';

import ButtonDropdown from 'components/ButtonDropdown';
import PaginatorComponent from 'components/Paginator';

import './styles.css';

const Actions = ({
  exportRoomsAvailabilityCsvInBackground,
  exportingRoomsAvailabilityCsv,
  disableExporting
}) => (
  <ButtonDropdown
    small
    title="Export Options"
    className="exportOptionsButton"
    menuPosition={ButtonDropdown.MENU_POSITION_TOP_RIGHT}
    isLoading={exportingRoomsAvailabilityCsv}
    disabled={disableExporting}
    tooltip={disableExporting && 'No rooms to export'}>
    <ButtonDropdown.Option
      onClick={exportRoomsAvailabilityCsvInBackground}
      disabled={exportingRoomsAvailabilityCsv}>
      Background rooms availability CSV export
    </ButtonDropdown.Option>
  </ButtonDropdown>
);

class Paginator extends React.Component<any> {
  render() {
    const {
      exportRoomsAvailabilityCsvInBackground,
      exportingRoomsAvailabilityCsv,
      disableExporting
    } = this.props;

    return (
      <PaginatorComponent
        pagination={this.props.pagination}
        onPageChange={this.props.onPageChange}
        ActionsComponent={() => (
          <Actions
            exportRoomsAvailabilityCsvInBackground={
              exportRoomsAvailabilityCsvInBackground
            }
            exportingRoomsAvailabilityCsv={exportingRoomsAvailabilityCsv}
            disableExporting={disableExporting}
          />
        )}
      />
    );
  }
}
export default Paginator;
